import './card-bar.css';

import { Card } from 'primereact/card';
import React, { ReactElement } from 'react';
import { useMediaQuery } from 'react-responsive';

type CardBarProps = {
  centered?: boolean;
  position?: string;
  children?: ReactElement;
};

export const CardBar = ({ centered = false, position = 'left', children }: CardBarProps) => {
  const isMobile = useMediaQuery({ query: '(max-width: 530px)' });
  const isTablet = useMediaQuery({ query: '(max-width: 767px)' });

  return (
    <div className="card-bar-container">
      <Card
        className={(isTablet ? 'm-2' : 'm-4') + ' card-bar'}
        style={{
          width: isMobile ? 'calc(100vw - 16px)' : 'max-content',
          [position]: 0,
          justifySelf: centered ? 'center' : 'start',
        }}
      >
        {children}
      </Card>
    </div>
  );
};
